export enum FreightType {
  NoFreight = 0,
  OwnFreightTable = 1,
  AutomatedFreightTable = 2,
}

export enum ConsentExpirationTime {
  THREE_MONTHS = 3,
  SIX_MONTHS = 6,
  TWELVE_MONTHS = 12,
  TWENTY_FOUR_MONTHS = 24,
}

export enum FreightOverheadType {
  Monetary = "1",
  Percentage = "2",
}
